import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ModalVideo from 'react-modal-video';

import PageLayout from './../layouts/PageLayout';
import RecentNews from './../components/Home/RecentNews';

import bloglg from './../assets/images/whatwedo/fountainwall.jpg';
import avatar3 from './../assets/images/avatar/avatar3.jpg';
import { emailValidation, firstNameValidation, noSpaceValidation, phoneOnChange, phoneValidation } from '../validation';

const EMAIL = 'Cleanairkelowna@gmail.com';

function AboutUs() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState();
  const [message, setMessage] = useState("");
  const [isFirstNameError, setIsFirstNameError] = useState(false);
  const [isEmailError, setIsEmailError] = useState(false);
  const [isPhonenumberError, setIsPhonenumberError] = useState(false);

  const openEmailCompose = (e) => {
    e.preventDefault();
    if (firstName.length > 2 && emailValidation(email) && phoneValidation(phonenumber)) {
      const subject = encodeURIComponent(`Quote request from ${firstName} ${lastName}`);
      const bodyLines = [
        `Name: ${firstName} ${lastName}`,
        `Email: ${email}`,
        `Phone: ${phonenumber || ''}`,
        '',
        `Message: ${message || ''}`,
      ];
      const body = encodeURIComponent(bodyLines.join('\n'));
      window.location.href = `mailto:${EMAIL}?subject=${subject}&body=${body}`;
    } else {
      if (!firstNameValidation(firstName)) setIsFirstNameError(true);
      else if (!emailValidation(email)) setIsEmailError(true);
      else if (!phoneValidation(phonenumber)) setIsPhonenumberError(true);
    }
  };

  const handleFirstName = (e) => { setIsFirstNameError(false); setFirstName(e.target.value); };
  const handleLastName = (e) => setLastName(e.target.value);
  const handleEmail = (e) => { noSpaceValidation(e.target.value) && setEmail(e.target.value); setIsEmailError(false); };
  const handlePhonenumber = (e) => { setIsPhonenumberError(false); phoneOnChange(e.target.value) && setPhonenumber(e.target.value); };
  const handleMessage = (e) => setMessage(e.target.value);

  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <div className="page-content">
        <PageLayout pageTitle="About Us" />

        <section className="content-inner about-sec bg-primary-light">
          <div className="container">
            <div className="row about-bx2 style-1 align-items-center">
              <div className="col-lg about-content ps-lg-5 m-b30">
                <div className="section-head">
                  <h2 className="title">About Kelowna Duct Cleaning</h2>
                  <p className="m-b20 lh-base">
                    Kelowna Duct Cleaning is a trusted locally based air duct cleaning company serving
                    Kelowna and surrounding areas, including West Kelowna, Lake Country and
                    Peachland. Our team of certified technicians specialize in providing professional
                    residential and commercial duct/dryer vent cleaning services designed to improve
                    indoor air quality and HVAC system efficiency.
                  </p>
                  <p className="m-b20 lh-base">
                    Our technicians use powerful equipment and industry-approved cleaning
                    methods to remove dust, allergens, mold particles, and debris that build up inside
                    air ducts over time.
                  </p>
                  <p className="m-b20 lh-base">
                    As a locally owned duct cleaning company, we take pride in serving our community
                    by providing reliable services, honest pricing, and outstanding workmanship.
                    Customer satisfaction and healthier indoor air are always our top priorities.
                  </p>
                  <p className="m-b30 lh-base">
                    If you are looking for professional duct cleaning, our team is ready to help keep your
                    properties clean, safe, and comfortable.
                  </p>

                  <h3 className="title mb-3 mt-5 pt-4">Vision and Mission</h3>
                  <div className="row g-4 mb-4">
                    <div className="col-md-6">
                      <div className="p-4 rounded bg-white shadow-sm h-100">
                        <h5 className="text-primary mb-3">Our Vision</h5>
                        <p className="m-0 lh-base">
                          To be the most trusted name in duct and dryer vent cleaning across Kelowna and the Okanagan, 
                          helping every home and business breathe cleaner, healthier air.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="p-4 rounded bg-white shadow-sm h-100">
                        <h5 className="text-primary mb-3">Our Mission</h5>
                        <p className="m-0 lh-base">
                          To deliver professional, reliable duct and dryer vent cleaning services with honest pricing 
                          and outstanding workmanship, putting customer satisfaction and healthier indoor air at the heart of everything we do.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <Link to={"/contact-us"} className="btn btn-lg btn-primary btn-shadow text-uppercase">Get a Quote</Link>
              </div>
            </div>
          </div>
        </section>

        <section className="form-sec bg-light">
          <div className="container">
            <div className="bg-primary form-wrapper1 style-1">
              <div className="row align-items-center">
                <div className="col-xl-3">
                  <div className="section-head">
                    <h5 className="sub-title text-white">Contact Us</h5>
                    <h5 className="title text-white">Request a Free Quote</h5>
                  </div>
                </div>
                <div className="col-xl-9">
                  <form className="dzForm" onSubmit={openEmailCompose}>
                    <div className="row">
                      <div className="col-md-4 m-b30">
                        <input type="text" className="form-control" placeholder="First Name" value={firstName} onChange={handleFirstName} />
                        {isFirstNameError && <p style={{ color: 'white', fontSize: '12px' }}>Please enter a valid first name. <span style={{ color: 'red' }}>*</span></p>}
                      </div>
                      <div className="col-md-4 m-b30">
                        <input type="text" className="form-control" placeholder="Last Name" value={lastName} onChange={handleLastName} />
                      </div>
                      <div className="col-md-4 m-b30">
                        <input type="text" className="form-control" placeholder="Email" value={email} onChange={handleEmail} />
                        {isEmailError && <p style={{ color: 'white', fontSize: '12px' }}>Please enter a valid email. <span style={{ color: 'red' }}>*</span></p>}
                      </div>
                      <div className="col-md-4 m-b30">
                        <input type="text" className="form-control" placeholder="Phone Number" value={phonenumber} onChange={handlePhonenumber} />
                        {isPhonenumberError && <p style={{ color: 'white', fontSize: '12px' }}>Please enter a valid phone number. <span style={{ color: 'red' }}>*</span></p>}
                      </div>
                      <div className="col-md-4 m-b30">
                        <input type="text" className="form-control" placeholder="Message" value={message} onChange={handleMessage} />
                      </div>
                      <div className="col-md-4 m-b30">
                        <button type="submit" className="btn btn-dark btn-block h-100">
                          Send via Email
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content-inner bg-white blog-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-xl-7 col-lg-12">
                <div className="section-head">
                  <h2 className="title">What Our Customers Say</h2>
                </div>
                <RecentNews />
              </div>
              <div className="col-xl-5 col-lg-12 m-b30">
                <div className="dz-card style-2" style={{ backgroundImage: `url(${bloglg})` }}>
                  <div className="dz-category">
                    <ul className="dz-badge-list">
                      <li><Link to={"#"} className="dz-badge">Kelowna, BC</Link></li>
                    </ul>
                  </div>
                  <div className="dz-info">
                    <h2 className="dz-title"><Link to={"/contact-us"} className="text-white">Professional Duct Cleaning in Kelowna & the Okanagan</Link></h2>
                    <div className="dz-meta">
                      <ul>
                        <li className="post-author">
                          <Link to={"/contact-us"}>
                            <img src={avatar3} alt="" className="me-2" />
                            <span>Clean Air Kelowna</span>
                          </Link>
                        </li>
                        <li className="post-date"><Link to={"/contact-us"}>140 Taylor Road, Kelowna, BC V1X 4E9</Link></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="sHZFs7z3PPw" onClose={() => setOpen(false)} />
    </>
  );
}
export default AboutUs;
